<template>
	<marketing-cards :marketing-card="customMarketingCard" v-if="customMarketingCard"/>
	<v-flex v-else class="no-front-page-marketing-cards">
		<v-flex>
			{{ $t("shopComponents.gt3.kioskPromotions.kioskPromotionsEmpty") }}
		</v-flex>
		<v-btn
			@click="goToProductCatalogue()"
			class="right green-btn btn-color btn-secondary">
			{{ $t("shopComponents.gt3.kioskPromotions.goToCatalogue") }}
		</v-btn>
	</v-flex>
</template>

<script>
import MarketingCards from "../../UtilityComponents/MarketingCards/MarketingCards.vue";
import landingPageMixin from "../../../mixins/LandingPage.mixin";
import {calculateDefaultCategoryId} from "../../../helper/CatalogHelper";
import {mapGetters} from "vuex";
import appConfig from "../../../appconfig";

export default {
	name: "KioskPromotions",
	components: {MarketingCards},
	mixins: [landingPageMixin],
	data() {
		return {
			customMarketingCard: null
		};
	},
	mounted() {
		this.customMarketingCard = this.getCustomMarketingCard("landingPageKiosk");
	},
	computed: {
		...mapGetters(["globalSelectedShop"]),
		channelAlias() {
			return appConfig.channelAlias();
		}
	},
	methods: {
		goToProductCatalogue() {
			const categoryId = calculateDefaultCategoryId(
				this.$store.getters.productCatalog.categories,
				this.channelAlias,
				this.globalSelectedShop.id
			);
			this.$router.push({
				name: "defaultProductCatalog",
				params: {
					categoryId: categoryId
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
	.no-front-page-marketing-cards {
		text-align: center;
		height: 100vh;
		display: flex;
		flex-direction: column;
		padding: 50px;
		font-size: 24px;
		.right.green-btn.btn-color.btn-secondary.v-btn {
			width: 500px;
			margin: auto;
		}
	}
</style>
